import axios from 'axios';
import { getDevRequestBlockReason } from './devSafety';

// All portal requests share a finite timeout so a stalled API cannot keep a
// React Query observer (and its loading spinner) alive indefinitely.
const httpClient = axios.create({
  timeout: 15000,
});

// Safety net while DEV and PROD use the same database and external services.
// The backend also enforces this policy; the browser guard prevents accidents.
httpClient.interceptors.request.use((config) => {
  const reason = getDevRequestBlockReason(config);
  if (!reason) return config;

  const error = new Error('Operación no disponible en DEV mientras comparte recursos con producción.');
  error.code = reason;
  return Promise.reject(error);
});

export default httpClient;
